import {
  AIAction,
  Direction,
  EnemyType,
  ItemType,
} from "../../../defines/enums"
import { CombatConfig, Position, RenderConfig } from "../../../defines/types"
import { generateRandomNumber } from "../../../utils/rng"
import { MobileEnemy } from "../mobile"

export class BounceEnemy extends MobileEnemy {
  protected _direction: Direction

  constructor(
    type: EnemyType,
    experience: number,
    combat: CombatConfig,
    position: Position,
    render: RenderConfig,
    name: string,
    direction?: Direction,
    optic?: ItemType
  ) {
    super(type, experience, combat, position, render, name, optic)

    if (direction !== undefined) {
      this._direction = direction
    } else {
      const randomDirection = generateRandomNumber(0, 3)
      switch (randomDirection) {
        case 0:
          this._direction = Direction.UP
          break
        case 1:
          this._direction = Direction.DOWN
          break
        case 2:
          this._direction = Direction.LEFT
          break
        default:
          this._direction = Direction.RIGHT
      }
    }
  }

  projectMove(): AIAction {
    this._state = AIAction.WAITING

    let targetX = this.position.x
    let targetY = this.position.y

    if (this._direction == Direction.UP) {
      targetY -= 1
    } else if (this._direction == Direction.DOWN) {
      targetY += 1
    } else if (this._direction == Direction.LEFT) {
      targetX -= 1
    } else if (this._direction == Direction.RIGHT) {
      targetX += 1
    }

    const player = window.engine.getPlayer()
    if (targetX == player.position.x && targetY == player.position.y) {
      window.engine.processEnemyAttack(this, true)
      this._state = AIAction.ATTACKING
    } else if (!window.engine.inBounds(targetX, targetY)) {
      if (this._direction == Direction.UP) {
        this._direction = Direction.DOWN
      } else if (this._direction == Direction.DOWN) {
        this._direction = Direction.UP
      } else if (this._direction == Direction.LEFT) {
        this._direction = Direction.RIGHT
      } else if (this._direction == Direction.RIGHT) {
        this._direction = Direction.LEFT
      }
    } else {
      this.position.x = targetX
      this.position.y = targetY
      this._state = AIAction.MOVING
      window.engine.requestUpdate()
    }

    return this._state
  }
}
